import React, { Component } from 'react';
import { OnCallUser } from '../Model/MonitoringModel';
import UserMenu from './UserMenu';
import userHelper from '../../../../Helpers/UserHelper';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Typography,
  LinearProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  AccordionActions,
  Snackbar,
  Stack,
  Divider,
  Box,
} from '@mui/material';
import { idToColor } from '../../../../Helpers/UtilityMethods';
import { CardWrapper } from '../../Common/CommonComponents';

interface Props {
  loading: boolean;
  onCallUsers: OnCallUser[];
  removeUserFromArray: (userId: string) => void;
}

interface State {
  expanded: string | false;
  showSnackbar: boolean;
  snackbarMessage: string;
}

class OnCallUsersList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      expanded: false,
      showSnackbar: false,
      snackbarMessage: '',
    };
  }

  handlePanelSelectionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      this.setState({ expanded: isExpanded ? panel : false });
    };

  getNameFromEmail = (emailId: string) => userHelper.getNameFromId(emailId);
  getInitials = (emailId: string) => userHelper.GetInitialsFromId(emailId);

  handleSnackbarClose = () => {
    this.setState({ showSnackbar: false });
  };

  removeUserFromArray = (userId: string) => {
    this.props.removeUserFromArray(userId);
    this.setState({
      snackbarMessage: 'User removed from on-call list',
      showSnackbar: true,
    });
  };

  render() {
    const { loading, onCallUsers } = this.props;
    const { expanded, showSnackbar, snackbarMessage } = this.state;

    return (
      <CardWrapper>
        {loading ? (
          <>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              Waiting... will load once onCallOfTheWeek is ready...
            </Typography>
            <LinearProgress sx={{ width: '100%' }} />
          </>
        ) : (
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
              On-call users in the system
            </Typography>
            <Divider />
            {onCallUsers.map((user) => (
              <Accordion
                key={user.Id}
                expanded={expanded === user.Id}
                onChange={this.handlePanelSelectionChange(user.Id)}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      overflow: 'hidden',
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {user.Name}
                    </Typography>
                    <Typography
                      sx={{
                        color: 'text.secondary',
                        fontSize: 14,
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {this.getNameFromEmail(user.EmailAddress)}
                    </Typography>
                  </Box>
                </AccordionSummary>

                <AccordionDetails>
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ flexWrap: 'wrap', overflow: 'hidden' }}
                  >
                    <Avatar sx={{ bgcolor: idToColor(user.Id), flexShrink: 0 }}>
                      {this.getInitials(user.EmailAddress)}
                    </Avatar>
                    <Stack sx={{ minWidth: 0 }}>
                      <Typography variant="caption">
                        Can be reached at:
                      </Typography>
                      <Typography
                        color="textSecondary"
                        sx={{
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {user.PhoneNumber}
                      </Typography>
                      <Typography
                        color="textSecondary"
                        sx={{
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                        }}
                      >
                        {user.EmailAddress}
                      </Typography>
                    </Stack>
                  </Stack>
                </AccordionDetails>

                <AccordionActions>
                  <UserMenu
                    onCallUser={user}
                    removeUser={(userId) => this.removeUserFromArray(userId)}
                  />
                </AccordionActions>
              </Accordion>
            ))}
          </Stack>
        )}

        {/* Snackbar */}
        <Snackbar
          open={showSnackbar}
          onClose={this.handleSnackbarClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          message={<span>{snackbarMessage}</span>}
        />
      </CardWrapper>
    );
  }
}

export default OnCallUsersList;
